<script>
import LABELS from '@/constants/labels'

export default {
  name: 'Term',
  data() {
    return {
      visible: false,
      idColorBg: '',
      arrNewText: [],
      color: '',
      editingIndex: '',
      maxAddText: 5,
      indexText: null,
      termCondition: false,
    }
  },

  computed: {
    mappingLabels() {
      return LABELS
    },
  },

  methods: {
    customScroll() {
      let allPage = document.getElementsByClassName('all-page')[0]
      if (!allPage.classList.contains('all-page-scroll')) {
        let el = document.getElementsByClassName('term-page')[0]
        el.classList.add('h-100vh')
      };
      let header = document.getElementsByClassName('header')[0]
      header.scrollIntoView();
    }
  },
  mounted() {
    this.customScroll()
  },
}
</script>

<template>
  <div>
    <s-header>作る前に…</s-header>
    <div class="term-page">
      <div class="term-page_container">
        <div class="wrap-top-content">
          <s-title>注意事項</s-title>
          <div class="wrap-stop">
            <div class="wrap-stop_item">
              <div class="wrap-stop_item-img">
                <img :src="require('@/assets/images/term-page/icon_1.png')" alt="">
              </div>
              <div class="wrap-stop_item-text">
                <div>個人として楽しむものです。営利目的での活用はご遠慮ください。</div>
                <div>人に配る際は品質を保つために透明の外装フィルムの上から貼ってください。</div>
              </div>
            </div>
            <div class="wrap-stop_item">
              <div class="wrap-stop_item-img">
                <img :src="require('@/assets/images/term-page/icon_2.png')" alt="">
              </div>
              <div class="wrap-stop_item-text">
                <div>公序良俗、ブランド棄損に抵触しそうな文字は打てない設定となっています。</div>
                <div>「MINTIA」のテキストを使用したい場合はロゴありを選択して作成してください。</div>
              </div>
            </div>
          </div>
        </div>
        <div class="wrap-content">
          <h2 class="term-page_title">
            {{ mappingLabels.TnC }}
          </h2>
          <p class="term-page_desc">
            本コンテンツ【「ミンティア」MYラベルメーカー】をご利用いただきありがとうございます。<br />本コンテンツのサービスご利用に際し、事前にこの利用規約をお読みいただき、ご理解いただきますようお願い申しあげます。
          </p>
  
          <div class="wrap-content_term-condition">
            <h3 class="title-condition">
              <img :src="require('@/assets/images/term-page/マスクグループ 51@2x.png')" alt="">
              <span>1</span>
            </h3>
            <div class="desc-condition">
              <p>
                本コンテンツで作成されたデザインの著作権は、全てアサヒグループ食品株式会社（以下「当社」といいます。）に帰属するものとします。
              </p>
            </div>
          </div>
  
          <div class="wrap-content_term-condition">
            <h3 class="title-condition">
              <img :src="require('@/assets/images/term-page/マスクグループ 51@2x.png')" alt="">
              <span>2</span>
            </h3>
            <div class="desc-condition">
              <p>
                当社は、本コンテンツで作成されたデザインについて、次の各事項を遵守した使用であることを条件に、お客様の利用を許諾するものとします。
              </p>
              <ul class="desc-condition-custom">
                <li>営利目的でない、個人の範囲での使用であること</li>
                <li>
                  第三者や当社の権利（著作権や商標権等の財産権、肖像権やプライバシー等の人格権を含みますが、これらに限られません。）を侵害する又は侵害するおそれのある使用でないこと
                </li>
                <li>法令又は公序良俗に反する使用でないこと</li>
                <li>
                  その他当社が不適切と判断する使用でないこと（アサヒグループで定める「ご利用規約」への違反を含みます。）
                  <!-- <a
                    href="https://www.asahigroup-holdings.com/privacy_policy/05/"
                    target="_blank"
                    rel="noopener"
                    >https://www.asahigroup-holdings.com/privacy_policy/05/</a
                  > -->
                </li>
              </ul>
            </div>
          </div>
  
          <div class="wrap-content_term-condition">
            <h3 class="title-condition">
              <img :src="require('@/assets/images/term-page/マスクグループ 51@2x.png')" alt="">
              <span>3</span>
            </h3>
            <div class="desc-condition">
              <p>
                ②の各事項に違反する使用を行った場合、それに関連して生じた一切のクレームや請求につき、お客様の責任と費用で解決いただくものとします。また、当該違反により当社に損害を与えた場合、お客様がその損害賠償の責任を負うものとします。
              </p>
            </div>
          </div>
  
          <div class="wrap-content_term-condition">
            <h3 class="title-condition">
              <img :src="require('@/assets/images/term-page/マスクグループ 51@2x.png')" alt="">
              <span>4</span>
            </h3>
            <div class="desc-condition">
              <p>
                本コンテンツの作成にあたって個人情報を記入いただいた場合においても、当社ではサーバーでの保管を含めて当該個人情報を取得いたしません。そのため、本コンテンツの作成完了（画像データ保存）後の当該個人情報の取扱いについては、画像データの保管や画像データを利用した印刷を含め、お客様自身で適切な管理をお願いいたします。
              </p>
            </div>
          </div>
  
          <div class="wrap-content_term-condition">
            <h3 class="title-condition">
              <img :src="require('@/assets/images/term-page/マスクグループ 51@2x.png')" alt="">
              <span>5</span>
            </h3>
            <div class="desc-condition">
              <p>
                ミンティアは、透明の外装フィルムを開封した後はお早めにお召し上がりいただくようお願いしております。そのため、ラベルは透明の外装フィルムの上から貼付してお楽しみください。
              </p>
            </div>
          </div>
        </div>
  
        <s-checkbox v-model="termCondition"
          >上記にご同意いただける場合は左の枠内にチェックを入れてください</s-checkbox
        >
  
        <div class="term-page_button-group">
          <router-link
            class="s-button blue-btn"
            :class="{ 'disabled-btn': !termCondition }"
            :style="{ 'background-color: red;': !termCondition }"
            :to="{ name: 'select-layout' }"
            :title="mappingLabels.makeSticker"
            >{{ mappingLabels.makeSticker }}</router-link
          >
          <router-link
            class="s-button white-blue-btn mt-3"
            :to="{ name: 'home' }"
            :title="mappingLabels.backText"
            >{{ mappingLabels.backText }}</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'term.scss';
</style>
